// app
export const SET_LOGIN_TOKEN = 'SET_LOGIN_TOKEN'
export const DELETE_TOKEN = 'DELETE_TOKEN'
export const SET_ACTIVE_INDEX = 'SET_ACTIVE_INDEX'
export const SET_USER_ROLE = 'SET_USER_ROLE'
// payment
export const GET_PAYMENT_LIST = 'GET_PAYMENT_LIST'
export const GET_PAYMENT_SETTING = 'GET_PAYMENT_SETTING'

// 新版支付
export const GET_PAYMENTS_LIST = 'GET_PAYMENTS_LIST'
export const GET_PAY_SWITCHES = 'GET_PAY_SWITCHES'

// ornament
export const GET_ORNAMENT_LIST = 'GET_ORNAMENT_LIST'
export const GET_ORNAMENT_TYPE = 'GET_ORNAMENT_TYPE'
export const SET_CURRENT_ORNAMENT = 'SET_CURRENT_ORNAMENT'
// buyList
export const GET_BUY_LIST = 'GET_BUY_LIST'
// saleList
export const GET_SALE_LIST = 'GET_SALE_LIST'
// userlist
export const GET_USER_LIST = 'GET_USER_LIST'
// article
export const GET_ARTICLE_LIST = 'GET_ARTICLE_LIST'
// withdraw
export const GET_WITHDRAW_LIST = 'GET_WITHDRAW_LIST'
// order
export const GET_ORDER_LIST = 'GET_ORDER_LIST'
// box_group
export const GET_BOX_GROUP = 'GET_BOX_GROUP'
// category
export const GET_CATEGORY_LIST = 'GET_CATEGORY_LIST'
export const GET_CATEGORIES = 'GET_CATEGORIES'
export const GET_CASE_LIST = 'GET_CASE_LIST'
// roll
export const GET_ROOM_LIST = 'GET_ROOM_LIST'
// synthesis
export const GET_SYNTHESIS_LIST = 'GET_SYNTHESIS_LIST'
// extract
export const GET_EXTRACT_ORDER_LIST = 'GET_EXTRACT_ORDER_LIST'
// 关键词
export const GET_KEYWORDS = 'GET_KEYWORDS'
